"use client"

import { createContext, useContext } from "react"

/* The host app declares who it is in its [locale]/layout.tsx (companyName /
   subcompany) and passes it to Layout, which forwards it to Analytics. Pages
   that emit their own dataLayer events need the same values, and cannot derive
   them from their own CMS data - a marketing landing page's groupSite field is
   the list of subsidiaries allowed to serve it, not the one currently serving
   it. Layout publishes them here so any descendant can read them (ASH-1854). */

export type SiteAnalytics = {
  companyName: string
  subcompany: string
}

const SiteAnalyticsContext = createContext<SiteAnalytics>({
  companyName: "",
  subcompany: "",
})

export const SiteAnalyticsProvider = SiteAnalyticsContext.Provider

export const useSiteAnalytics = () => useContext(SiteAnalyticsContext)
